module.exports = __webpack_public_path__ + "img/solicitante.d1435ae9.webp";